<template>
  <v-card style="text-align: left"
          :elevation="0">
    <v-card-subtitle class="px-0 pt-0 pb-1">
      <!--  style="padding: 0  50px" -->
      <div class="is_flex_between mx-10 text--secondary">
        <v-sheet class="d-flex align-center text--secondary">
          <span class="px-1">{{ $t('label_product') }}</span>/<span class="px-1">{{ $t('label_The_module') }}</span>/
          <span class="d-flex align-center px-1 text--secondary">
            <mrc_ess_svgIcon style="font-size: 24px;margin-right: 5px"
                             icon-class="diamond02"></mrc_ess_svgIcon>{{ $t('label_function') }}
          </span>/
          <span class="d-flex align-center px-1 text--secondary">
            <mrc_ess_svgIcon style="font-size: 24px;margin-right: 5px"
                             icon-class="mouseButton"></mrc_ess_svgIcon>
            {{ $t('label_button') }}
          </span>
        </v-sheet>
        <span class="mr-14">{{ $t('label_clientType') }}</span>
      </div>
    </v-card-subtitle>
    <v-card-text class="pa-0">
      <tree-list :disabled="disabled"
                 :tree-data="list"
                 @getRowTreeData="getRowTreeData"
                 v-model="ids"
                 :options="options"
                 @handle="handle"
                 v-if="isload"></tree-list>
    </v-card-text>
  </v-card>
</template>

<script>
import treeList from './VueTree'
/**
 * @params uuids 默认显示的uuid数组
 * @params list 树列表数据
 * @params disabled 禁用选择
 * @params isload 数据传输 完加载组件
 * @event getData 获取封装好的数据
 */
export default {
  components: { treeList },
  props: {
    uuids: {
      type: Array,
      default: () => [],
    },
    list: {
      type: Array,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    isload: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      treeData: [],
      ids: [],
      options: {
        label: 'names',
        checkbox: true,
        checkedOpen: true,
        folderBold: true,
        // 这个是选中的时候把父级的id也选到了
        idsWithParent: true,
        depthOpen: 3,
        openIcon: 'arrow_right',
        closeIcon: 'arrow_drop_down',
        halfCheckedIcon: 'iconfont icon-minus-square',
        checkedIcon: 'iconfont icon-checkbox_on',
        uncheckedIcon: 'iconfont icon-check_box_outline_blank',
      },
      func_button_list: [],
      respData: [],
      rowTreeData: null,
    }
  },
  created () { },
  mounted () {
    this.treeData = this.list
    if (this.uuids.length > 0) {
      this.ids = Array.isArray(this.toMyArray(this.uuids))
        ? this.toMyArray(this.uuids).map((item) => {
          return item
        })
        : []
    }
    this.func_button_list = []
    this.findFunc(this.list)
  },
  methods: {
    getCheckData () {
      const data = this.generateData(this.ids, this.func_button_list)
      // console.log(this.ids)
      // console.log(this.func_button_list)
      return data
    },
    handle (item) {
      console.log(item)
    },
    getRowTreeData (obj) {
      this.rowTreeData = obj
    },
    generateData (ids, arr) {
      /**
       *
       * 把所有功能提取出来
       * {function_uuid: "",sub:[]}
       *
       */
      // 因为回显传function_uuid 的话会让下
      // 面的子级都被选中 所以，ids只有button的uuid 所以 要再次循环筛选一次把按钮的父级找出来
      // 选中的功能列表
      let func_list = []
      ids.forEach((i) => {
        arr.forEach((j) => {
          j.sub &&
            j.sub.length > 0 &&
            j.sub.forEach((k) => {
              if (k.uuid == i) {
                if (func_list)
                  if (func_list.indexOf(j) <= -1) {
                    func_list.push(j)
                  }
              }
            })
        })
      })
      // 需要上传的结构
      let needData = []
      // 将 func_list  改成需要的结构
      func_list.forEach((item, index) => {
        needData.push({
          function_uuid: item.uuid,
          button_uuids: [],
          button_uuid: [],
        })
        if (item.sub && item.sub.length > 0) {
          item.sub.forEach((j) => {
            needData[index].button_uuids.push(j.uuid)
          })
        }
      })

      // 将 ids 里的 功能和按钮id  修改到 needData里
      // 再循环选中的功能列表下的按钮

      needData.forEach((item) => {
        if (item.button_uuids.length <= 0) return
        item.button_uuids.forEach((btn) => {
          ids.forEach((selid) => {
            if (btn == selid) {
              item.button_uuid.push(selid)
            }
          })
        })
      })
      // 删除多余的button_uuids
      needData.forEach((item) => {
        delete item.button_uuids
        if (item.button_uuid.length > 0) {
          item.button_uuid = item.button_uuid.join()
        }
      })
      return needData
    },
    // 递归查找所有的功能列表
    findFunc (arr) {
      arr.forEach((item) => {
        if (item.type == 3) {
          this.func_button_list.push(item)
        } else {
          if (item.sub && item.sub.length > 0) {
            this.findFunc(item.sub)
          }
        }
      })
    },
    // 转换获取的选中id数据
    toMyArray (val) {
      if (val.length <= 0) return
      let list = []

      val.forEach((item) => {
        // list.push(item.function_uuid)
        if (item.button_uuid || item.button_uuid.length > 0) {
          if (
            Object.prototype.toString.call(item.button_uuid).indexOf('String') >
            0
          ) {
            item.button_uuid.split(',').forEach((it) => {
              list.push(it)
            })
          }
          if (
            Object.prototype.toString.call(item.button_uuid).indexOf('Array') >
            0
          ) {
            item.button_uuid.forEach((it) => {
              list.push(it)
            })
          }
        }
      })
      return list
    },
  },
  computed: {},
  watch: {
    ids: {
      handler (val) {
        const data = this.generateData(val, this.func_button_list)
        this.$emit('getData', data)
      },
      deep: true,
    },
    list: {
      handler (val) {
        this.func_button_list = []
        this.findFunc(val)
      },
      deep: true,
    },
    uuids: {
      handler (val) {
        this.ids = this.toMyArray(val).map((item) => {
          return item
        })
        this.func_button_list = []
        this.findFunc(this.list)
      },
      deep: true,
    },
  },
}
</script>

<style scoped>
/deep/.v-card__text > .vue-tree-list {
  background-color: #ffffff;
  border-radius: 8px;
}
/deep/ .ancestry > .vue-tree-item {
  border-radius: 8px;
  margin-bottom: 16px;
  background-color: #f5f5f5;
}
.item-wrapper {
  height: 64px;
}
</style>
